export default __webpack_public_path__ + "images/20ce4b02030db4c2745c0f737eadcbc0-accessDenied--dark.png";